import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import PageTemplate from './Template'

const HeaderControl = (props) => {
  return <PageTemplate props={props} layout="header" title="ค้นหา" />
}

export const headerControlTester = rankWith(3, scopeEndsWith('header'))

export default withJsonFormsControlProps(HeaderControl)
